const detectionTypeData = ['click', 'hover'];

export default detectionTypeData;
